import React from "react";

const WagerTypeButtons = ({ status, wt, wagerName, onChangeWT }) => {
  let wtButton;
  if (status) {
    wtButton = (
      <button
        type="button"
        className="btn btn-outline-info active"
        key={wt + "1"}
        onClick={() => {
          onChangeWT(false, wt);
        }}
      >
        {wagerName}
      </button>
    );
  } else {
    wtButton = (
      <button
        type="button"
        className="btn btn-outline-info"
        key={wt + "2"}
        onClick={() => {
          onChangeWT(true, wt);
        }}
      >
        {wagerName}
      </button>
    );
  }

  return <>{wtButton}</>;
};

export default WagerTypeButtons;
